import { render, staticRenderFns } from "./DIASRealEstateLuovutuksenEhdot.vue?vue&type=template&id=78fbfa1c&"
import script from "./DIASRealEstateLuovutuksenEhdot.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateLuovutuksenEhdot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports